import React from "react";
import './LandingColumnActivity.css'
import AlertMahuti from "../../components/mahuti-alerts/AlertMahuti";
import { useSelector } from "react-redux";
import { currectStepActivityComponent } from "../../utils/stepperUtils";




export default function LandingColumnActivity() {

    const orderCart = useSelector(state => state.reducer);
    return <div className="landingColumnActivity container-fluid-lg ">

        {false && <AlertMahuti role='danger' desription='Alerttt' />}
            <div id='contains-stepper' className="landingPageStep">
                {currectStepActivityComponent(orderCart.currentStep)}
            </div>
    </div>
}